@if(!isEmpty){
<div class="flex-cards">
    <div class="two-cards">
        <div class="welcom-card">
            <div class="d-flex flex-column gap-2">
                <h1>
                    Welcome back to <span class="text-blue">AdMore</span>
                </h1>
                <p>
                    Create powerful ad campaigns with AI-powered optimization
                </p>
            </div>
            <button pButton class="custom-btn bg-blue" icon="pi pi-plus" [routerLink]="['/create-campaign/step1']"
                routerLinkActive="router-link-active"> Create Campaign </button>
        </div>
        <p-card class="quick-actions-card">
            <h1>Quick Actions</h1>
            <div class="two-buttons">
                <button pButton class="custom-btn blue-border">Optimize Bids</button>
                <button pButton class="custom-btn blue-border">View Reports</button>
            </div>
            <button pButton class="custom-btn blue-border w-full">Audience Insights</button>
        </p-card>
    </div>
    <div class="two-cards">
        <p-card class="line-graph-card">
            <h1 class="card-title">
                Spend & Balance Trend
            </h1>
            <p class="card-description">
                Track your spending and remaining budget
            </p>
            <p-chart type="line" [data]="totalSpendBalanceData" [options]="lineOptions" height="60vh" />
        </p-card>
        <div class="stats-cards">
            <p-card styleClass="stat-card-content total-spend">
                <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex gap-2 flex-column">
                        <h3 class="stat-title">
                            Total Spend
                        </h3>
                        <span class="value">
                            47,003 SAR
                        </span>
                        <p>
                            <span class="text-green">
                                +8.2% 
                            </span>
                            from last month
                        </p>
                    </div>
                    <div>
                        <img src="../../../../assets/icons/wallet-icon.svg" alt="">
                    </div>
                </div>
            </p-card>
            <p-card styleClass="stat-card-content">
                <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex gap-2 flex-column">
                        <h3 class="stat-title">
                            Remaining Balance
                        </h3>
                        <span class="value">
                            47,003 SAR
                        </span>
                        <p>
                            <span class="text-green">
                                +8.2% 
                            </span>
                            from last month
                        </p>
                    </div>
                    <div>
                        <img src="../../../../assets/icons/money-dollar-circle-line.svg" alt="">
                    </div>
                </div>
            </p-card>
            <p-card styleClass="stat-card-content ">
                <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex gap-2 flex-column">
                        <h3 class="stat-title">
                            Total Active Campaign
                        </h3>
                        <span class="value">
                            2
                        </span>

                    </div>
                    <div>
                        <img src="../../../../assets/icons/notify-icon.svg" alt="">
                    </div>
                </div>
            </p-card>
        </div>
    </div>
    <div class="list-container">
        <div class="d-flex flex-wrap justify-content-between gap-1 align-items-center mb-3">
            <h1 class="campaigns-section-title mb-0">Campaigns</h1>
            <button pButton class="custom-btn blue-border">
                <i class="pi pi-eye"></i>
                View All Campaigns
            </button>
        </div>
        <p-card styleClass="list-item">
            <h1 class="name-content">
                Summer Product Launch
                <label for="">Active</label>
            </h1>
            <div class="list-item-data">
                <div class="data-item">
                    <label for="">
                        Off/On:
                    </label>
                    <p-toggleswitch />
                </div>
                <div class="data-item">
                    <label for="">
                        Budget:
                    </label>
                    <span>
                        9,098 SAR
                    </span>
                </div>
                <div class="data-item">
                    <label for="">
                        Spend:
                    </label>
                    <span>
                        9,098 SAR
                    </span>
                </div>
                <div class="data-item">
                    <label for="">
                        Reach:
                    </label>
                    <span>
                        5,985
                    </span>
                </div>
                <div class="data-item">
                    <label for="">
                        Cost Per Result:
                    </label>
                    <span>
                        0.012 SAR
                    </span>
                </div>
                <div class="data-item">
                    <label for="">
                        Actions:
                    </label>
                    <span>
                        <img src="../../../../assets/icons/edit-line.svg" alt="">
                    </span>
                </div>
            </div>
        </p-card>
        <p-card styleClass="list-item">
            <h1 class="name-content">
                Summer Product Launch
                <label for="" class="green-label">Active</label>
            </h1>
            <div class="list-item-data">
                <div class="data-item">
                    <label for="">
                        Off/On:
                    </label>
                    <p-toggleswitch />
                </div>
                <div class="data-item">
                    <label for="">
                        Budget:
                    </label>
                    <span>
                        9,098 SAR
                    </span>
                </div>
                <div class="data-item">
                    <label for="">
                        Spend:
                    </label>
                    <span>
                        9,098 SAR
                    </span>
                </div>
                <div class="data-item">
                    <label for="">
                        Reach:
                    </label>
                    <span>
                        5,985
                    </span>
                </div>
                <div class="data-item">
                    <label for="">
                        Cost Per Result:
                    </label>
                    <span>
                        0.012 SAR
                    </span>
                </div>
                <div class="data-item">
                    <label for="">
                        Actions:
                    </label>
                    <span>
                        <img src="../../../../assets/icons/edit-line.svg" alt="">
                    </span>
                </div>
            </div>
        </p-card>

    </div>

</div>
}@else{
    <div class="empty-container">
        <img src="../../../../../../../assets/images/team-brainstorming.png" alt="">
        <h1>Your first campaign starts here</h1>
        <p>New to Admore? No problem. Set up your first social media ad campaign and watch the results roll in. It's easier
            than you think.</p>
    </div>
}